<template>
	<div v-if="!loadingCategoriesAndOffers">


		<div v-for="(categoryAndOffers, ci) in categoriesAndOffers" :key="ci">
			
			<div class="section-title mb-5 mt-10" v-if="categoryAndOffers.offers.length > 0">
				{{ categoryAndOffers.category.name }}
			</div>


			<div class="offers-list__container">
				<div v-for="(offer, oi) in categoryAndOffers.offers" :key="oi">
					<RectangleOfferTile :offer="offer" @click="offerTileClicked(offer)"></RectangleOfferTile>
				</div>
			</div>

		</div>


		<div v-if="loadingCategoriesAndOffers" class="offers-list__container">
			<v-skeleton-loader :elevation="4" type="list-item-avatar-three-line" v-for="n in 20" :key="n"
				color="var(--v-skeleton-loader-color)">
			</v-skeleton-loader>
		</div>


		<OfferDetailsDialog :offer="selectedOffer" @report-offer="openReportOfferDialog" />

		<ReportOfferDialog />

	</div>
</template>



<script setup>

import { computed, ref, provide } from "vue";
import { OfferStore } from "@/store/offerStore";

import RectangleOfferTile from '@/components/Tiles/Offer/Rectangle-Offer-Tile.vue';
import OfferDetailsDialog from '../../Offer/StartOfferDialogComponents/Offer-Details-Dialog.vue';
import ReportOfferDialog from '../../Offer/StartOfferDialogComponents/Report-Offer-Dialog.vue';

const offerStore = OfferStore();
const selectedOffer = computed(() => offerStore.selectedOffer);
const loadingCategoriesAndOffers = computed(() => offerStore.loadingCategoriesAndOffers);

const categoriesAndOffers = computed(() => {
	return offerStore.categoriesAndOffers;
});

const offerDetailsDialogOpen = ref(false);
provide("offerDetailsDialogOpen", offerDetailsDialogOpen);

const reportOfferDialogOpen = ref(false);
provide("reportOfferDialogOpen", reportOfferDialogOpen);

const offerTileClicked = (offer) => {
	selectedOffer.value = offer;
	offerDetailsDialogOpen.value = true;
};

const openReportOfferDialog = () => {
	offerDetailsDialogOpen.value = false;
	reportOfferDialogOpen.value = true;
};

</script>
